class Warenkorb {

    constructor(listener = false) {
        this.warenkorbMap = new Map();
        this.listener = listener;
        this.EMPTY_WARENKORB_TEXT = 'Warenkorb ist leer';

        this.#warenkorbCookieLesen();
    }

    initBuch() {
        const listenerDiv = document.querySelector(this.listener);
        if (listenerDiv) {
            listenerDiv.addEventListener('click', () => {
                const buchId = listenerDiv.getAttribute('data-buch-id');
                this.#warenkorbPositionPlusMinus(buchId, 1);
            });
        } else {
            console.warn(`Element for selector ${this.listener} not found.`);
        }
    }

    initShop() {
        const listenerDiv = document.querySelector(this.listener);
        if (listenerDiv) {
            listenerDiv.addEventListener('click', (evt) => {
                if (evt.target.className == 'shop__buch-warenkorb') {
                    const buchDiv = evt.target.closest('.shop__buch');
                    const buchId = buchDiv.getAttribute('data-buch-id');
                    const anzahl = parseInt(buchDiv.querySelector('.shop__buch-input').value, 10);
                    if (!isNaN(anzahl) && anzahl > 0) {
                        this.#warenkorbPositionPlusMinus(buchId, anzahl);
                    }
                }
            });
        } else {
            console.warn(`Element for selector ${this.listener} not found.`);
        }
    }

    initWarenkorb() {
        this.#buchPreisanzeigeAktualisieren();
        this.#warenkorbTotal();
        const listenerDiv = document.querySelector(this.listener);
        if (listenerDiv) {
            listenerDiv.addEventListener('click', (evt) => {
                if (evt.target.className == 'warenkorb-seite__buch-loeschen' || evt.target.closest('.warenkorb-seite__buch-loeschen')) {
                    const buchDiv = evt.target.closest('.warenkorb-seite__buch');
                    const buchId = buchDiv.getAttribute('data-buch-id');
                    this.#warenkorbPositionLoeschen(buchId);
                }
            });
        } else {
            console.warn(`Element for selector ${this.listener} not found.`);
        }

        document.addEventListener('warenkorbAnzahlEvent', (evt) => {
            // console.log('warenkorbAnzahlEvent');
            this.#buchPreisanzeigeAktualisieren();
            this.#warenkorbTotal();
        });
    }

    // https://github.com/js-cookie/js-cookie
    #warenkorbCookieLesen() {
        // Cookie lesen
        const cookie = Cookies.get('EDULINO_WARENKORB');
        if (cookie != undefined) {
            const array = JSON.parse(cookie);
            array.forEach(element => {
                this.warenkorbMap.set(element[0], element[1]);
            });
            this.#warenkorbSymbolAktualisieren();
        }
    }

    #warenkorbCookieSchreiben() {
        // Map zu JSON
        const json = JSON.stringify(Array.from(this.warenkorbMap.entries()));
        // Cookie schreiben
        Cookies.set('EDULINO_WARENKORB', json, { expires: 7, path: '/' })
        this.#warenkorbSymbolAktualisieren();
    }

    #warenkorbSymbolAktualisieren() {
        const warenkorbZahl = document.querySelector('.warenkorb__zahl');
        let anzahl = 0;
        this.warenkorbMap.forEach(warenkorbPosition => {
            anzahl += parseInt(warenkorbPosition, 10);
        });
        warenkorbZahl.innerText = anzahl;
    }

    #buchPreisanzeigeAktualisieren() {
        let buchDivs = document.querySelectorAll('.warenkorb-seite__buch');
        for (let buchDiv of buchDivs) {
            const inputDiv = buchDiv.querySelector('.warenkorb-seite__buch-input');
            let buchAnzahl = parseInt(inputDiv.value, 10) || 1;
            const einzelpreis = parseFloat(inputDiv.dataset['einzelpreis']) || 0;
            let gesamtpreis = (einzelpreis * buchAnzahl).toFixed(2);
            let gesamtpreisDiv = buchDiv.querySelector('.warenkorb-seite__buch-preis');
            gesamtpreisDiv.dataset['gesamtpreis'] = gesamtpreis;
            gesamtpreisDiv.innerText = 'CHF ' + gesamtpreis;
        }
        this.#warenkorbTotal();
        this.#warenkorbAktualisieren('.warenkorb-seite__buch', '.warenkorb-seite__buch-input');
    }

    /** 
     * Entfernt die Produkte im Warenkorb inklusive der Spaltenüberschriften und der Summe
    */
    warenkorbSeiteLeeren() {
        // Nur die Warenkorb-Bücher entfernen (innerhalb des warenkorb-containers)
        const warenkorbContainer = document.querySelector('.warenkorb-seite__warenkorb-container');
        if (warenkorbContainer) {
            const buecher = warenkorbContainer.querySelectorAll('.warenkorb-seite__buch');
            for (let buchElement of buecher) {
                buchElement.remove();
            }

            // Total zurücksetzen
            const totalAnzeigen = warenkorbContainer.querySelectorAll('.warenkorb-seite__total--buch');
            for (let totalAnzeige of totalAnzeigen) {
                totalAnzeige.innerText = 'CHF 0.00';
            }
        }

        // Kontaktformular nur innerhalb des warenkorb-containers entfernen, nicht das gesamte
        const kontaktformular = document.querySelector('.warenkorb-seite__warenkorb-container .warenkorb-seite__kontaktformular');
        if (kontaktformular) {
            kontaktformular.remove();
        }
    }

    #warenkorbAktualisieren(buch, input) {
        const buecher = document.querySelectorAll(buch);
        for (let buchElement of buecher) {
            const anzahl = parseInt(buchElement.querySelector(input).value, 10);
            let buchId = buchElement.dataset.buchId;
            if (!isNaN(anzahl) && anzahl > 0) {
                this.warenkorbMap.set(buchId, anzahl);
            }
        }
        this.#warenkorbCookieSchreiben();
        this.#bestellungFormularAktualisieren();
    }

    #warenkorbPositionPlusMinus(produkt, plusMinus) {
        let anzahlAlt = 0;
        if (this.warenkorbMap.has(produkt)) {
            anzahlAlt = this.warenkorbMap.get(produkt);
        }
        let anzahlNeu = anzahlAlt + plusMinus;
        if (anzahlNeu > 0) {
            this.warenkorbMap.set(produkt, anzahlNeu);
        } else {
            this.#warenkorbPositionLoeschen(produkt);
        }
        this.#warenkorbCookieSchreiben();
    }

    warenkorbLoeschen() {
        // console.log('warenkorbLoeschen');
        this.warenkorbMap.clear();
        this.#warenkorbCookieSchreiben();
    }

    #warenkorbTotal() {
        // console.log('#warenkorbTotal');
        const preisTotalDiv = document.querySelectorAll('.warenkorb-seite__buch-preis--buch');
        const gesamtpreisData = 'gesamtpreis';
        const totalAnzeigen = document.querySelectorAll('.warenkorb-seite__total--buch');

        let preisTotal = 0;
        for (let buchElement of preisTotalDiv) {
            const gesamtpreis = parseFloat(buchElement.dataset[gesamtpreisData]);
            if (!isNaN(gesamtpreis)) {
                preisTotal += gesamtpreis;
            }
        }
        for (let totalAnzeige of totalAnzeigen) {
            totalAnzeige.innerText = 'CHF ' + preisTotal.toFixed(2);
        }
    }

    #warenkorbPositionLoeschen(buchId) {
        // console.log('#warenkorbPositionLoeschen', buchId);
        if (this.warenkorbMap.has(buchId)) {
            this.warenkorbMap.delete(buchId);
            this.#warenkorbCookieSchreiben();
            document.querySelector(`.warenkorb-seite__buch[data-buch-id="${buchId}"]`).remove();
        }
        this.#buchPreisanzeigeAktualisieren();
        if (this.warenkorbMap.size == 0) {
            document.querySelector('.warenkorb-seite__kontaktformular').remove();
        }
    }

    #bestellungFormularAktualisieren() {
        const bestellungTextarea = document.querySelector('textarea[name="fields[bestellung]"]');
        if (!bestellungTextarea) {
            return;
        }

        let bestellungText = '';
        let gesamtbetrag = 0;

        const buchDivs = document.querySelectorAll('.warenkorb-seite__buch');

        for (const buchDiv of buchDivs) {
            const inputDiv = buchDiv.querySelector('.warenkorb-seite__buch-input');
            if (!inputDiv) continue;

            const anzahl = parseInt(inputDiv.value, 10) || 0;
            if (anzahl <= 0) continue;

            const produktName = inputDiv.dataset.produkt || 'Unbekanntes Produkt';
            const kategorie = inputDiv.dataset.kategorie || 'Keine Kategorie';
            const einzelpreis = parseFloat(inputDiv.dataset.einzelpreis) || 0;
            const gesamtpreis = einzelpreis * anzahl;

            gesamtbetrag += gesamtpreis;
            bestellungText += `${anzahl} × ${produktName} (${kategorie}) zu je CHF ${einzelpreis.toFixed(2)}\n`;
        }

        if (bestellungText) {
            bestellungText += `\nSumme: CHF ${gesamtbetrag.toFixed(2)}`;
        } else {
            bestellungText = this.EMPTY_WARENKORB_TEXT;
        }

        bestellungTextarea.value = bestellungText;

        const container = bestellungTextarea.closest('.fui-input-container');
        if (container) {
            container.setAttribute('data-replicated-value', bestellungText);
        }
    }

    bestellungFormularZuruecksetzen() {
        const bestellungTextarea = document.querySelector('textarea[name="fields[bestellung]"]');
        if (bestellungTextarea) {
            bestellungTextarea.value = this.EMPTY_WARENKORB_TEXT;

            const container = bestellungTextarea.closest('.fui-input-container');
            if (container) {
                container.setAttribute('data-replicated-value', this.EMPTY_WARENKORB_TEXT);
            }
        }

        this.#warenkorbSymbolAktualisieren();

        const totalAnzeigen = document.querySelectorAll('.warenkorb-seite__total--buch');
        for (let totalAnzeige of totalAnzeigen) {
            totalAnzeige.innerText = 'CHF 0.00';
        }
    }
}